import {QuestionLayoutContext} from './QuestionComponentContext.mjs';
import Base from './containers/Base.jsx';
import QuestionGroupContainer from './QuestionGroupContainer.jsx';
import React from 'react';

const QuestionGroups = ({currentPage, validationErrors = []}) => {
  return (currentPage.questionGroups || []).map((questionGroup, i) => {
    const type = questionGroup.type;

    return (
      <QuestionLayoutContext.Consumer key={`${questionGroup.key}-${i}`}>
        {QuestionLayouts => {
          const QuestionGroupComponent = QuestionLayouts[type] || Base;
          return (
            <QuestionGroupContainer
              GroupComponent={QuestionGroupComponent}
              key={`${questionGroup.key}-${i}`}
              page={currentPage}
              validationErrors={validationErrors}
              questionGroup={questionGroup}
            />
          );
        }}
      </QuestionLayoutContext.Consumer>
    );
  });
};

export default QuestionGroups;
